import React from 'react';
// 이 모듈은 클래스 외에 전역 리셋(* , body, a, ul/li ...)도 함께 담고 있어
// 다른 페이지가 그 리셋에 의존한다. 클래스를 쓰지 않더라도 import 는 유지한다.
import './../styles/Main.module.css';
import OnePage from './renewal/OnePage';

const Main = () => <OnePage />;

export default Main;
